import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from 'src/app/core/services/api-base.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserAuthDataService extends ApiBaseService {
  logout(): Observable<any> {
    const httpOptions = this.getHttpOptions(true);
    return this.get(environment.logout_url, httpOptions);
  }

  changePassword(passwordDTO: any): Observable<any> {
    const httpOptions = this.getHttpOptions(true);
    return this.post(environment.change_password_url, passwordDTO, httpOptions);
  }
}
